import React from "react";
import { BLOG_INFO, useLang } from "../context/LangContext";

export default function BlogBadge({ blog, className = "" }) {
  const { lang } = useLang();
  const info = BLOG_INFO[blog] || { pt: blog, en: blog, color: "#64748b" };
  return (
    <span
      data-testid={`blog-badge-${blog}`}
      className={`inline-flex items-center gap-1.5 rounded-full px-2.5 py-1 text-xs font-semibold uppercase tracking-wide ${className}`}
      style={{ color: info.color, backgroundColor: `${info.color}1f`, border: `1px solid ${info.color}55` }}
    >
      <span className="h-1.5 w-1.5 rounded-full" style={{ backgroundColor: info.color }} />
      {lang === "pt" ? info.pt : info.en}
    </span>
  );
}
